<script setup lang="ts">

import { defineProps } from 'vue'

defineProps({
  minWidth: {
    type: String,
    required: true,
  }
});

</script>

<template>
  <div :class="'flex-1 flex items-center text-nowrap overflow-hidden'" :style="{ minWidth: minWidth + 'rem' }">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">

</style>